import { Menu } from '@admin/models';

export const MENUS: Readonly<Menu>[] = [
  {
    id: 'tyres',
    title: 'Tyre',
    resourceName: 'Tyres',
    groupName: 'Tyre',
    submenus: [
      {
        id: 'tyreManufacturers',
        title: 'Manufacturers',
        resourceName: 'Tyres',
        groupName: 'Tyre',
        businessLineCode: 'common',
      },
      { id: 'brands', title: 'Brands', resourceName: 'Tyres', groupName: 'Tyre', businessLineCode: 'common' },
      { id: 'markings', title: 'Markings', resourceName: 'Tyres', groupName: 'Tyre', businessLineCode: 'common' },
      {
        id: 'markingTypes',
        title: 'Marking Types',
        resourceName: 'Tyres',
        groupName: 'Tyre',
        businessLineCode: 'common',
      },
      {
        title: 'Synonyms',
        submenus: [
          {
            id: 'synonyms',
            title: 'Global',
            resourceName: 'Tyres',
            groupName: 'Tyre',
            businessLineCode: 'tc',
            params: { key: 'synonymDescription.scope', value: 'global' },
          },
          {
            id: 'synonyms',
            title: 'Passenger Cars and Light Trucks',
            resourceName: 'Tyres',
            groupName: 'Tyre',
            businessLineCode: 'tc',
            params: { key: 'synonymDescription.scope', value: 'business_line' },
          },
          {
            id: 'synonyms',
            title: 'Trucks and Buses',
            resourceName: 'Tyres',
            groupName: 'Tyre',
            businessLineCode: 'tk',
          },
          { id: 'synonyms', title: 'Two Wheeler', resourceName: 'Tyres', groupName: 'Tyre', businessLineCode: 'tw' },
          { id: 'synonyms', title: 'Beyond Road', resourceName: 'Tyres', groupName: 'Tyre', businessLineCode: 'br' },
        ],
      },
      {
        title: 'Ranges',
        submenus: [
          {
            id: 'ranges',
            title: 'Passenger Cars and Light Trucks',
            resourceName: 'Tyres',
            groupName: 'Tyre',
            businessLineCode: 'tc',
          },
          { id: 'ranges', title: 'Trucks and Buses', resourceName: 'Tyres', groupName: 'Tyre', businessLineCode: 'tk' },
          { id: 'ranges', title: 'Two Wheeler', resourceName: 'Tyres', groupName: 'Tyre', businessLineCode: 'tw' },
          { id: 'ranges', title: 'Beyond Road', resourceName: 'Tyres', groupName: 'Tyre', businessLineCode: 'br' },
        ],
      },
      {
        title: 'Products',
        submenus: [
          {
            id: 'tyreCategories',
            title: 'Passenger Cars and Light Trucks',
            resourceName: 'Tyres',
            groupName: 'Tyre',
            businessLineCode: 'tc',
          },
          {
            id: 'products',
            title: 'Trucks and Buses',
            resourceName: 'Tyres',
            groupName: 'Tyre',
            businessLineCode: 'tk',
          },
          { id: 'products', title: 'Two Wheeler', resourceName: 'Tyres', groupName: 'Tyre', businessLineCode: 'tw' },
          { id: 'products', title: 'Beyond Road', resourceName: 'Tyres', groupName: 'Tyre', businessLineCode: 'br' },
        ],
      },

      undefined,
      {
        title: 'Dimensions',
        submenus: [
          {
            id: 'tyreDimensions',
            title: 'Passenger Cars and Light Trucks',
            resourceName: 'Tyres',
            groupName: 'Tyre',
            businessLineCode: 'tc',
          },
          {
            id: 'dimensions',
            title: 'Trucks and Buses',
            resourceName: 'Tyres',
            groupName: 'Tyre',
            businessLineCode: 'tk',
          },
          { id: 'dimensions', title: 'Two Wheeler', resourceName: 'Tyres', groupName: 'Tyre', businessLineCode: 'tw' },
          { id: 'dimensions', title: 'Beyond Road', resourceName: 'Tyres', groupName: 'Tyre', businessLineCode: 'br' },
        ],
      },

      undefined,
      {
        title: 'Tyres',
        submenus: [
          {
            id: 'tcTyres',
            title: 'Passenger Cars and Light Trucks',
            resourceName: 'Tyres',
            groupName: 'Tyre',
            businessLineCode: 'tc',
          },
          {
            id: 'tkTyres',
            title: 'Trucks and Buses',
            resourceName: 'Tyres',
            groupName: 'Tyre',
            businessLineCode: 'tk',
          },
          { id: 'twTyres', title: 'Two Wheeler', resourceName: 'Tyres', groupName: 'Tyre', businessLineCode: 'tw' },
          { id: 'brTyres', title: 'Beyond Road', resourceName: 'Tyres', groupName: 'Tyre', businessLineCode: 'br' },
        ],
      },
      {
        title: 'Additional info',
        submenus: [
          {
            id: 'additionalInfoes',
            title: 'Trucks and Buses',
            resourceName: 'Tyres',
            groupName: 'Tyre',
            businessLineCode: 'tk',
          },
          {
            id: 'additionalInfoes',
            title: 'Two Wheeler',
            resourceName: 'Tyres',
            groupName: 'Tyre',
            businessLineCode: 'tw',
          },
          {
            id: 'additionalInfoes',
            title: 'Beyond Road',
            resourceName: 'Tyres',
            groupName: 'Tyre',
            businessLineCode: 'br',
          },
        ],
      },
    ],
  },
  {
    id: 'vehicles',
    title: 'Vehicle',
    resourceName: 'Vehicles',
    groupName: 'Vehicle',
    submenus: [
      {
        title: 'Makers',
        submenus: [
          { id: 'makers', title: 'Car', resourceName: 'Vehicles', groupName: 'Vehicle', businessLineCode: '4w' },
          {
            id: 'motorBikeMakers',
            title: 'MotorBike',
            resourceName: 'Vehicles',
            groupName: 'Vehicle',
            businessLineCode: 'mbk',
          },
        ],
      },
      {
        title: 'Segments',
        submenus: [
          { id: 'carSegments', title: 'Car', resourceName: 'Vehicles', groupName: 'Vehicle', businessLineCode: '4w' },
          {
            id: 'motorBikeSegments',
            title: 'MotorBike',
            resourceName: 'Vehicles',
            groupName: 'Vehicle',
            businessLineCode: 'mbk',
          },
        ],
      },

      {
        title: 'Types',
        submenus: [
          { id: 'carTypes', title: 'Car', resourceName: 'Vehicles', groupName: 'Vehicle', businessLineCode: '4w' },
          {
            id: 'motorBikeTypes',
            title: 'MotorBike',
            resourceName: 'Vehicles',
            groupName: 'Vehicle',
            businessLineCode: 'mbk',
          },
        ],
      },
      {
        title: 'Vehicles',
        submenus: [
          { id: 'cars', title: 'Car', resourceName: 'Vehicles', groupName: 'Vehicle', businessLineCode: '4w' },
          {
            id: 'motorBikes',
            title: 'MotorBike',
            resourceName: 'Vehicles',
            groupName: 'Vehicle',
            businessLineCode: 'mbk',
          },
        ],
      },

      {
        title: 'Technical Ids',
        submenus: [
          {
            id: 'carTechnicalIds',
            title: 'Car',
            resourceName: 'Vehicles',
            groupName: 'Vehicle',
            businessLineCode: '4w',
          },
          {
            id: 'motorBikeTechnicalIds',
            title: 'MotorBike',
            resourceName: 'Vehicles',
            groupName: 'Vehicle',
            businessLineCode: 'mbk',
          },
        ],
      },

      {
        title: 'Cnit/Tvv',
        submenus: [
          { id: 'carCnits', title: 'Car', resourceName: 'Vehicles', groupName: 'Vehicle', businessLineCode: '4w' },
        ],
      },

      {
        title: 'Dimensions',
        submenus: [
          { id: 'carDimensions', title: 'Car', resourceName: 'Vehicles', groupName: 'Vehicle', businessLineCode: '4w' },
          {
            id: 'motorBikeDimensions',
            title: 'MotorBike',
            resourceName: 'Vehicles',
            groupName: 'Vehicle',
            businessLineCode: 'mbk',
          },
        ],
      },
      {
        title: 'Homologation',
        submenus: [
          {
            id: 'carHomologations',
            title: 'Car',
            resourceName: 'Vehicles',
            groupName: 'Vehicle',
            businessLineCode: '4w',
          },
          {
            id: 'motorBikeHomologations',
            title: 'MotorBike',
            resourceName: 'Vehicles',
            groupName: 'Vehicle',
            businessLineCode: 'mbk',
          },
        ],
      },
      {
        title: 'Exclusive Map',
        submenus: [
          {
            id: '',
            title: 'Car',
            resourceName: 'Vehicles',
            groupName: 'Vehicle',
            businessLineCode: '4w',
            path: 'vehicles/car-exclusive-map',
          },
        ],
      },
      {
        title: 'Synonyms',
        submenus: [
          {
            id: 'carSynonyms',
            title: 'Synonym',
            resourceName: 'Vehicles',
            groupName: 'Vehicle',
            businessLineCode: '4w',
          },
        ],
      },
      {
        title: 'Translations',
        submenus: [
          {
            id: 'translationCarMakers',
            title: 'Makers',
            resourceName: 'Vehicles',
            groupName: 'Vehicle',
            businessLineCode: '4w',
          },
          {
            id: 'translationCarSegments',
            title: 'Segments',
            resourceName: 'Vehicles',
            groupName: 'Vehicle',
            businessLineCode: '4w',
          },
          {
            id: 'translationCarTypes',
            title: 'Types',
            resourceName: 'Vehicles',
            groupName: 'Vehicle',
            businessLineCode: '4w',
          },
          {
            id: 'translationCarEnergies',
            title: 'Energy',
            resourceName: 'Vehicles',
            groupName: 'Vehicle',
            businessLineCode: '4w',
          },
        ],
      },
      {
        title: 'Registration Plate',
        submenus: [
          {
            id: 'carPlates',
            title: 'Car',
            resourceName: 'Vehicles',
            groupName: 'Vehicle',
            businessLineCode: '4w',
          },
        ],
      },
    ],
  },
  {
    id: 'parsing',
    title: 'Parsing',
    resourceName: 'Parsing',
    groupName: 'Parsing',
    submenus: [
      {
        title: 'Parsing Backlog',
        submenus: [
          {
            id: 'residuals',
            title: 'Passenger Cars and Light Trucks',
            resourceName: 'Parsing',
            groupName: 'Parsing',
            businessLineCode: 'tc',
          },
          {
            id: 'residuals',
            title: 'Trucks and Buses',
            resourceName: 'Parsing',
            groupName: 'Parsing',
            businessLineCode: 'tk',
          },
          {
            id: 'residuals',
            title: 'Two Wheeler',
            resourceName: 'Parsing',
            groupName: 'Parsing',
            businessLineCode: 'tw',
          },
        ],
      },
      {
        title: 'Exception Table',
        submenus: [
          {
            id: 'exceptionTables',
            title: 'Passenger Cars & Light Trucks',
            resourceName: 'Parsing',
            groupName: 'Parsing',
            businessLineCode: 'tc',
          },
        ],
      },
      {
        title: 'Business Sources Quality',
        submenus: [
          {
            id: 'prBusinessSourcesQualities',
            title: 'Business Sources Quality',
            resourceName: 'Parsing',
            groupName: 'Parsing',
            businessLineCode: 'pr',
          },
        ],
      },
      {
        title: 'Bar Code Table',
        submenus: [
          {
            id: 'tcBarCodeSpecs',
            title: 'Passenger Cars & Light Trucks',
            resourceName: 'Parsing',
            groupName: 'Parsing',
            businessLineCode: 'tc',
          },
        ],
      },
      {
        title: 'Rubber Type Table',
        submenus: [
          {
            id: 'twRubberTypes',
            title: 'Two Wheeler',
            resourceName: 'Parsing',
            groupName: 'Parsing',
            businessLineCode: 'tw',
          },
        ],
      },
      {
        title: 'Raw data replace',
        submenus: [
          {
            id: 'tcRawDataReplaces',
            title: 'Passenger Cars and Light Trucks',
            resourceName: 'Parsing',
            groupName: 'Parsing',
            businessLineCode: 'tc',
          },
          {
            id: 'tkRawDataReplaces',
            title: 'Trucks and Buses',
            resourceName: 'Parsing',
            groupName: 'Parsing',
            businessLineCode: 'tk',
          },
          {
            id: 'twRawDataReplaces',
            title: 'Two Wheeler',
            resourceName: 'Parsing',
            groupName: 'Parsing',
            businessLineCode: 'tw',
          },
          {
            id: 'brRawDataReplaces',
            title: 'Beyond Road',
            resourceName: 'Parsing',
            groupName: 'Parsing',
            businessLineCode: 'br',
          },
        ],
      },
      {
        title: 'Decoding',
        submenus: [
          {
            id: 'excludeDecodes',
            title: 'Decoding and Passenger car',
            resourceName: 'Parsing',
            groupName: 'Parsing',
            businessLineCode: 'pr',
          },
        ],
      },
       {
        title: 'Segmentation Table',
        submenus: [
          {
            id: 'brEtrmaSegmentations',
            title: 'Beyond Road',
            resourceName: 'Parsing',
            groupName: 'Parsing',
            businessLineCode: 'br',
          },
        ],
      },
    ],
  },
  {
    id: 'parameters',
    title: 'Parameters',
    resourceName: 'Parameters',
    groupName: 'Parameters',
    submenus: [
      {
        title: 'Languages',
        submenus: [
          {
            id: 'languages',
            title: '4 Wheelers',
            resourceName: 'Parameters',
            groupName: 'Parameters',
            businessLineCode: '4w',
          },
        ],
      },
      {
        title: 'Constant Tables',
        submenus: [
          {
            id: 'plyRatings',
            title: 'Ply Rating',
            resourceName: 'Parameters',
            groupName: 'Parameters',
            businessLineCode: 'tk',
          },
          {
            id: 'tkLabellingSystems',
            title: 'Labelling System',
            resourceName: 'Parameters',
            groupName: 'Parameters',
            businessLineCode: 'tk',
          },
        ],
      },
    ],
  },
  {
    id: 'monitoring',
    title: 'Monitoring',
    resourceName: 'Monitoring',
    groupName: 'Monitoring',
    submenus: [
      {
        title: 'Monitoring',
        submenus: [
          {
            id: 'monitoring',
            title: 'Full View Monitoring',
            resourceName: 'Monitoring',
            groupName: 'Monitoring',
            businessLineCode: 'mo',
            path: 'monitor/full-view-monitoring',
          }
        ],
      },
      {
        title: 'Smart Matching',
        submenus: [
          {
            id: 'tcSmartMatchingFailedRecords',
            title: 'PC/LT Smart Matching Failed Records',
            resourceName: 'Monitoring',
            groupName: 'Monitoring',
            businessLineCode: 'mo',
          },
        ],
      },
       {
        title: 'Tyre Full View',
        submenus: [
          {
            id: 'tcPlcFinals',
            title: 'PC/LT Tyre Full View',
            resourceName: 'Monitoring',
            groupName: 'Monitoring',
            businessLineCode: 'mo',
          },
        ],
      },
    ],
  },
  {
    id: 'notification',
    title: 'Notification',
    resourceName: 'Notifications',
    groupName: 'Referential',
    businessLineCode: 'rf',
    submenus: [
      {
        title: 'Pending Approvals',
        submenus: [
          {
            id: 'vehicle-approvals',
            title: 'Vehicle',
            path: 'vehicles/entity-change-requests',
            resourceName: 'Notifications',
            groupName: 'Referential',
            businessLineCode: 'rf',
          },
        ],
      },
    ],
  }
];
